import HealingIcon from "@mui/icons-material/Healing"; // Import other relevant icons
import VisibilityIcon from "@mui/icons-material/Visibility";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import AssignmentIcon from "@mui/icons-material/Assignment";
import HistoryIcon from "@mui/icons-material/History";
import AttachmentIcon from "@mui/icons-material/Attachment";
export const sections = [
  {
    name: "Chief Complaints",
    icon: <HealingIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "History",
    icon: <HistoryIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Examinations",
    displayName: "Examination/Vitals",
    icon: <VisibilityIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Drawing Pad",
    icon: <MedicalServicesIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Tests/Investigations",
    displayName: "Tests Advised",
    icon: <AssignmentIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Diagnosis",
    icon: <LocalHospitalIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Medications",
    icon: <LocalOfferIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Procedures",
    icon: <MedicalServicesIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Medical Advice",
    icon: <MedicalServicesIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Follow Up/Referral",
    icon: <MedicalServicesIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Adult Vaccination",
    icon: <MedicalServicesIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Attachments",
    icon: <AttachmentIcon style={{ marginRight: "8px" }} />,
  },
];
export const sectionsForQuickConsultation = [
  {
    name: "Chief Complaints",
    icon: <HealingIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "History",
    icon: <HistoryIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Examinations",
    displayName: "Examination/Vitals",
    icon: <VisibilityIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Tests/Investigations",
    displayName: "Tests Advised",
    icon: <AssignmentIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Diagnosis",
    icon: <LocalHospitalIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Adult Vaccination",
    icon: <MedicalServicesIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Medications",
    icon: <LocalOfferIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Procedures",
    icon: <MedicalServicesIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Medical Advice",
    icon: <MedicalServicesIcon style={{ marginRight: "8px" }} />,
  },
  {
    name: "Follow Up/Referral",
    icon: <MedicalServicesIcon style={{ marginRight: "8px" }} />,
  },
];

export const historySections = [
  "Initial Observation",
  "History of Past Illness",
  "History of Present Illness",
  "Family History",
  "Drug History",
  "Allergies",
  "Addiction History",
  "Surgeries",
  "Menstrual History",
  "Adult Vaccination",
];
export const historySectionsForQuickConsultation = [
  "History of Past Illness",
  "History of Present Illness",
  "Family History",
  "Drug History",
  "Allergies",
  "Addiction History",
  "Surgeries",
  "Menstrual History",
  "Adult Vaccination",
];

export const initialSuggestions = {
  "Chief Complaints": {
    aiDriven: [],
    ruleDriven: [],
  },
  Examinations: {
    ruleDriven: [],
    aiDriven: [],
  },
  Procedures: {
    ruleDriven: [],
    aiDriven: [],
  },
  Medications: {
    ruleDriven: [],
    aiDriven: [],
  },
  Diagnosis: {
    ruleDriven: [],
    aiDriven: [],
  },
  "Adult Vaccination": {
    ruleDriven: [],
    aiDriven: [],
  },
  "Tests/Investigations": {
    ruleDriven: [],
    aiDriven: [],
  },
  // Advices: {
  //   ruleDriven: [],
  //   aiDriven: [],
  // },
  // Add suggestions for other sections
};

export const initalMedicalBackgroundData = {
  "Initial Observation": {
    prev: [],
    new: [],
  },
  "History of Past Illness": {
    prev: [],
    new: [],
  },
  "History of Present Illness": {
    prev: [],
    new: [],
  },
  "Family History": {
    prev: [],
    new: [],
  },
  "Drug History": {
    prev: [],
    new: [],
  },
  Allergies: {
    prev: [],
    new: [],
  },
  "Addiction History": {
    prev: [],
    new: [],
  },
  "Menstrual History": {
    prev: [],
    new: [],
  },
  Surgeries: {
    prev: [],
    new: [],
  },
  "Adult Vaccination": {
    prev: [],
    new: [],
  },
};
export const initalMedicalBackgroundDataForQuickConsultation = {
  "Initial Observation": {
    prev: [],
    new: [],
  },
  "History of Past Illness": {
    prev: [],
    new: [],
  },
  "History of Present Illness": {
    prev: [],
    new: [],
  },
  "Family History": {
    prev: [],
    new: [],
  },
  "Drug History": {
    prev: [],
    new: [],
  },
  Allergies: {
    prev: [],
    new: [],
  },
  "Addiction History": {
    prev: [],
    new: [],
  },
  "Menstrual History": {
    prev: [],
    new: [],
  },
  Surgeries: {
    prev: [],
    new: [],
  },
  "Adult Vaccination": {
    prev: [],
    new: [],
  },
};
export const conditionStatus = [
  "Active",
  "Recurrence",
  "Relapse",
  "Inactive",
  "Remission",
  "Resolved",
  "Unknown",
];

export const durationType = [
  {
    value: "minutes",
    display: "Minutes",
  },
  {
    value: "hours",
    display: "Hours",
  },
  {
    value: "days",
    display: "Days",
  },
  {
    value: "weeks",
    display: "Weeks",
  },
  {
    value: "months",
    display: "Months",
  },
  {
    value: "years",
    display: "Years",
  },
];

export const medicineFrequencyOptions = [
  "5mL-0-5mL",
  "10mL-0-10mL",
  " 2.5mL-0-2.5mL",
  "2tsp-2tsp-2tsp",
  "0-0-1",
  "0-1-1",
  "1-1-1",
  "1-0-0",
  "0-1-0",
  "1-0-1",
  "1-1-0",
];

export const medicineInstructionOptions = ["After Meal", "Before Meal"];
export const medicineDurationTypesOptions = [
  "Days",
  "Weeks",
  "Months",
  "Years",
];
